import script from "./Closed.vue?vue&type=script&setup=true&lang=js"
export * from "./Closed.vue?vue&type=script&setup=true&lang=js"

import "./Closed.vue?vue&type=style&index=0&id=11c8c1a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c8c1a3"]])

export default __exports__